import { RepositoryBuilder } from 'alto-orm/lib/orm'

import User from './user'

AuthRepository = new RepositoryBuilder

AuthRepository.registerRelation(User, '/auth/crud/users')

export default AuthRepository # takes backendUrl and auth
